module.exports = __webpack_public_path__ + "img/eg_pic_1.40dfb8ff.png";